<template>
  <v-container fluid bg>
    <div class="text-center h1">
      <h1>Formulaire de contact</h1>
    </div>

    <form ref="form" @submit.prevent="sendEmail">
      <v-text-field dense placeholder="Nom" name="user_name" required />
      <v-text-field
        dense
        type="email"
        placeholder="Email"
        name="user_email"
        required
      />
      <v-textarea
        dense
        placeholder="Message"
        name="message"
        required
      ></v-textarea>
      <div class="text-right">
        <v-btn type="submit">Envoyer</v-btn>
      </div>
    </form>
    <v-snackbar v-model="snackbar" :timeout="timeout">
      {{ text }}

      <template v-slot:action="{ attrs }">
        <v-btn color="success" text v-bind="attrs" @click="snackbar = false">
          Close
        </v-btn>
      </template>
    </v-snackbar>
    <v-snackbar v-model="snackbarError" :timeout="timeout">
      {{ textError }}

      <template v-slot:action="{ attrs }">
        <v-btn color="blue" text v-bind="attrs" @click="snackbar = false">
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
import { init, sendForm } from "@emailjs/browser";

export default {
  created() {
    init("user_yBUvBgsuDyOpxKu5oLYfM");
  },
  data: () => ({
    snackbar: false,
    snackbarError: false,
    text: "L'email a été envoyé avec succès.",
    textError: "Un problème est survenu lors de l'envoi.",
    timeout: 2000,
    name: "John Doe",
    email: {
      value: "jo@hnd.oe",
      valid: true
    },
    features: ["Reactivity", "Encapsulation", "Data Binding"],
    selection: {
      member: "0",
      framework: "vue",
      features: []
    },
    message: {
      text: `Dear Mr. President,\n...`,
      maxlength: 255
    },
    submitted: false,
    emailRegExp: /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/
  }),
  methods: {
    // submit form handler
    sendEmail: function() {
      this.submitted = true;
      sendForm("service_o2b3phj", "template_rsxvnpf", this.$refs.form).then(
        () => {
          this.snackbar = true;
        },
        () => {
          this.snackbarError = true;
        }
      );
    },
    // validate by type and value
    validate: function(type, value) {
      if (type === "email") {
        this.email.valid = this.isEmail(value) ? true : false;
      }
    },
    // check for valid email adress
    isEmail: function(value) {
      return this.emailRegExp.test(value);
    },
    // check or uncheck all
    checkAll: function(event) {
      this.selection.features = event.target.checked ? this.features : [];
    }
  },
  watch: {
    // watching nested property
    "email.value": function(value) {
      this.validate("email", value);
    }
  }
};
</script>
